import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from 'components';
import { AppAuthGuard } from './security/app-auth-guard';
import { AcVi00 } from './controllers/ac-vi00.component';
import { SsvmnComponent } from './ssvmn.component';
import { DashboardComponent } from './dashboard.component';
import { ControllerSpecificationService } from './services/controller-specification.service';
import { ServiceLocator } from './services/ServiceLocator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home.component';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorService } from './services/error.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AvVi00Component } from './controllers/av-vi00/av-vi00.component';
import { PublicComponent } from './public/public.component';
import { AuthModule } from './auth/auth.module';
declare var $: any;

@NgModule({
  declarations: [
    AppComponent,
    AcVi00,
    SsvmnComponent,
    DashboardComponent,
    HomeComponent,
    AvVi00Component,
    PublicComponent,
  ],
  entryComponents: [AcVi00],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 20000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'increasing',
      closeButton: true
    }),
    NgxSpinnerModule,
    ModalModule.forRoot(),
    AuthModule
  ],
  providers: [DatePipe, AppAuthGuard, ControllerSpecificationService, { provide: ErrorHandler, useClass: ErrorService }],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    ServiceLocator.injector = this.injector;
  }
}
